import React from "react";
import css from "./Header.module.css";
import Nav from "./Nav";
import Logo from "./Logo";
import Hamburger from "./Hamburger";
import { Link } from "react-router-dom";

const Header = ({ client }) => {
  return (
    <nav className={`${css.main} flex between shadow background_white`}>
      <Logo />
      <div className="flex">
        <Hamburger />
        <Nav />
        
        <Link className={css.cta} to="/contact">
          Contact
        </Link>
      </div>
    </nav>
  );
};

export default Header;
